var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission('has_inline_help'))?_c('v-tooltip',{attrs:{"content-class":"tooltip-popup","max-width":_vm.width,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"pl-2",attrs:{"medium":_vm.medium,"color":_vm.color}},on),[_vm._v(_vm._s(_vm.icon))])]}}],null,false,3510325275)},[_vm._v(" "),_vm._t("message")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08478e4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/Lightbulb.vue
// module id = null
// module chunks = 